import { createAsyncThunk } from '@reduxjs/toolkit';
import { ExpertisesApi } from '../../../api/base/Expertises';

export const fetchExpertises = createAsyncThunk(
  'expertises/fetchExpertises',
  async (): Promise<Array<any>> => {
    const response = await ExpertisesApi.getExpertises();
    return response.data.data;
  },
);

export const fetchExpertisesBeat = createAsyncThunk(
  'expertises/fetchExpertisesBeat',
  async (): Promise<Array<any>> => {
    const response = await ExpertisesApi.getExpertisesBeat();
    return response.data.data;
  },
);
